import { BaseService } from "mrb/core";

class AppVersionInfoService extends BaseService {
    getLatest(abortSignal = null) {
        const url = this.routeService.getLatest();
        return this.apiClient.get(url, null, abortSignal);
    }

    enable(id, abortSignal = null) {
        const url = this.routeService.enable(id);
        return this.apiClient.patch(url, null, null, abortSignal);
    }

    disable(id, abortSignal = null) {
        const url = this.routeService.disable(id);
        return this.apiClient.patch(url, null, null, abortSignal);
    }
}

export default AppVersionInfoService;
